import { IEnvironment } from './environment';

export const environmentDefault: IEnvironment = {
    alternativeLogo: false,
    // TODO: apiUrl is deprecated. Use apiBaseUrl instead.
    apiUrl: 'https://api-testnet.ergoplatform.com/api/v0',
    apiBaseUrl: 'https://api-testnet.ergoplatform.com',
    apiUrlV1: 'https://api-testnet.ergoplatform.com/api/v1',
    blockchain: {
        coinName: 'Erg',
    },
    defaultLocale: 'en',
    environments: [
        {
            name: 'TestNet',
            url: 'https://api-testnet.ergoplatform.com',
        },
        {
            name: 'Mainnet',
            url: 'https://explorer.ergoplatform.com',
        },
    ],
    isLoggerEnabled: true,
};
